import { Radar } from '@orgus/ui/icons';
import ControlSettings from '../../control/ControlSettings.tsx';
import type { SettingsSection } from '../registry.ts';

const section: SettingsSection = {
  id: 'session-control',
  title: 'Session control',
  description: 'Approvals and budget stops for every Claude Code session on a machine.',
  order: 30,
  group: 'agents',
  keywords: ['hooks', 'every session', 'control', 'approvals', 'budget', 'messages'],
  icon: Radar,
  Component: ControlSettings,
  needs: { module: 'control', feature: 'Session control', instead: 'Approvals still reach you here for sessions you start from the web.' },
};
export default section;
